// CourtTypeView.js
import React from "react";
import DynamicCard from "./MainCardComponent";
import NOKTable from "../Customers/customers/ManageCustomer/NOK";
import GuarantorsTable from "../Customers/customers/ManageCustomer/GuarantorDetails";
import BusinessDetailsTable from "../Customers/customers/ManageCustomer/BusinessDetails";
import GroupRolesTable from "../Customers/groups/ManageGroup/GroupRoles";
import GroupMembersTable from "../Customers/groups/ManageGroup/Members";
import InterestPaymentMethodsTable from "../SetupManagement/InterestPaymentMethods";
import MpesaStatemets from "../Customers/customers/ManageCustomer/MpesaStatements";
import Customer360 from "../Customers/customer360";
import CustomerLoanApplication from "../Customers/customers/LoanDAta";
import CustomerStatementDetails from "../Customers/customers/ManageCustomer/CustomerStatement";
import CustomerSecurityTable from "../Customers/customers/ManageCustomer/CustomerSecurity";
import CollateralAssetTable from "../Customers/customers/ManageCustomer/CollateralAsset";
import CustomerDevicesTable from "../Customers/customers/ManageCustomer/CustomerDevices";
import GroupStatementDetails from "../Customers/groups/ManageGroup/GroupStatemant";
import ImprestApprovalsTable from "../../scenes/HRManagemenet/ImprestApplications";
import ImprestApplicationsByUserTable from "../../scenes/HRManagemenet/ImprestByUser";
import ImprestSurrenderTable from "../../scenes/HRManagemenet/ImprestSurrender/surrendar";
import LeaveApplicationsTable from "../../scenes/HRManagemenet/LeaveApplications";
import LeaveApprovalsTable from "../../scenes/HRManagemenet/LeaveApprovals";
import PCApplicationsTable from "../../scenes/HRManagemenet/PettyCash/PCApplications";
import PCApplicationsByUserTable from "../../scenes/HRManagemenet/PettyCash/PCApplicationsByUser";
import StaffClaimsTable from "../../scenes/HRManagemenet/StaffClaim";
import StaffClaimsByUserTable from "../../scenes/HRManagemenet/StaffClaimByUser";
import ApprovedLeavesTable from "../HRManagemenet/ApprovedLeaves";
import ApprovedStaffClaimsTable from "../HRManagemenet/ApprovedStaffClaim";
import ApprovedImprestTable from "../HRManagemenet/ApprovedImprest";

export const MyImprests = () => {
  return (
    <DynamicCard>
      <ImprestApplicationsByUserTable />
    </DynamicCard>
  );
};
export const ImprestApprovals = () => {
  return (
    <DynamicCard>
      <ImprestApprovalsTable />
    </DynamicCard>
  );
};
export const ImprestSurrender = () => {
  return (
    <DynamicCard>
      <ImprestSurrenderTable />
    </DynamicCard>
  );
};
export const AllPettyCash = () => {
  return (
    <DynamicCard>
      <PCApplicationsTable />
    </DynamicCard>
  );
};
export const ApprovedLeaves = () => {
  return (
    <DynamicCard>
      <ApprovedLeavesTable />
    </DynamicCard>
  );
};
export const ApprovedStaffClaims = () => {
  return (
    <DynamicCard>
      <ApprovedStaffClaimsTable />
    </DynamicCard>
  );
};
export const ApprovedImprest = () => {
  return (
    <DynamicCard>
      <ApprovedImprestTable />
    </DynamicCard>
  );
};

export const MyPettyCash = () => {
  return (
    <DynamicCard>
      <PCApplicationsByUserTable />
    </DynamicCard>
  );
};
export const MyLeaveApplications = () => {
  return (
    <DynamicCard>
      <LeaveApplicationsTable />
    </DynamicCard>
  );
};
export const LeaveApprovals = () => {
  return (
    <DynamicCard>
      <LeaveApprovalsTable />
    </DynamicCard>
  );
};
export const StaffClaimApprovals = () => {
  return (
    <DynamicCard>
      <StaffClaimsTable />
    </DynamicCard>
  );
};
export const MyStaffClaims = () => {
  return (
    <DynamicCard>
      <StaffClaimsByUserTable />
    </DynamicCard>
  );
};




export const NextOfKin = () => {
  return (
    <DynamicCard>
      <NOKTable />
    </DynamicCard>
  );
};
export const Guarantor = () => {
  return (
    <DynamicCard>
      <GuarantorsTable />
    </DynamicCard>
  );
};
export const BusinessDetails = () => {
  return (
    <DynamicCard>
      <BusinessDetailsTable />
    </DynamicCard>
  );
};
export const GroupRoles = () => {
  return (
    <DynamicCard>
      <GroupRolesTable />
    </DynamicCard>
  );
};
export const Members = () => {
  return (
    <DynamicCard>
      <GroupMembersTable />
    </DynamicCard>
  );
};

export const MpesaStatements = () => {
  return (
    <DynamicCard>
      <MpesaStatemets />
    </DynamicCard>
  );
};

export const BioData = () => {
  return (
    <DynamicCard>
      <Customer360 />
    </DynamicCard>
  );
};

export const LoanData = () => {
  return (
    <DynamicCard>
      <CustomerLoanApplication />
    </DynamicCard>
  );
};
export const CustomerStatement = () => {
  return (
    <DynamicCard>
      <CustomerStatementDetails />
    </DynamicCard>
  );
};
export const CustomerCollateral = () => {
  return (
    <DynamicCard>
      <CustomerSecurityTable />
    </DynamicCard>
  );
};

export const CollateralAssets = () => {
  return (
    <DynamicCard>
      <CollateralAssetTable />
    </DynamicCard>
  );
};

export const CustomerDevices = () => {
  return (
    <DynamicCard>
      <CustomerDevicesTable />
    </DynamicCard>
  );
};

export const GroupStatement = () => {
  return (
    <DynamicCard>
      <GroupStatementDetails />
    </DynamicCard>
  );
};
